import React from "react";
import Logo from "../HeaderBar/Logo";
import { useTranslation } from "react-i18next";

const HeaderSection = ({ setIsOpenPortal, challengeActive, setLocation, passwordReset }) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <span
          style={{
            cursor: "pointer",
            color: "#000",
          }}
          onClick={() => setLocation() && setIsOpenPortal(false)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="10.471" height="10.471" viewBox="0 0 10.471 10.471">
            <g id="Group_6084" data-name="Group 6084" transform="translate(-1161.87 -393.729)">
              <path
                id="Path_10326"
                data-name="Path 10326"
                d="M5118.577-21688.564l9.057,9.057"
                transform="translate(-3956 22083)"
                fill="none"
                stroke="#000"
                strokeWidth="2"
              />
              <path
                id="Path_10327"
                data-name="Path 10327"
                d="M5127.634-21688.564l-9.057,9.057"
                transform="translate(-3956 22083)"
                fill="none"
                stroke="#000"
                strokeWidth="2"
              />
            </g>
          </svg>
        </span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          marginBottom: "1.5vw",
        }}
      >
        <Logo logoBlack />

        <p style={{ fontSize: "0.85vw" }}>
          {passwordReset || challengeActive ? t("L1_PASSWORD_RESET_HEADLINE") : t("L1_SIGN_IN_HEADLINE")}
        </p>
      </div>
    </>
  );
};

export default HeaderSection;
